export default [
  {
    header: "العلاقة مع الوزارة",
    icon: "PieChartIcon",
    children: [
      // {
      //   title: "طلبات المنظمة ",
      //   icon: "PieChartIcon",
      //   route: "charts-apex-chart",
      // },
      {
        title: "المراسلات",
        route: "messaging",
        icon: "MailIcon",
        slug:'ngo_messages'
      },
      {
        title: "الثناءات و العقوبات",
        route: "incentives",
        icon: "AwardIcon",
        slug:'ngo_incentives'
      },
      {
        title: "البيانات المالية",
        route: "financial-data",
        icon: "BriefcaseIcon",
        slug:'ngo_financial_info'
      },
      {
        title: "الأموال المُحولة للخارج",
        route: "money-transferred-abroad",
        icon: "CreditCardIcon",
        slug:'ngo_money_transferred_abroad'
      },
      {
        title: "طلبات المنحة المالية",
        route: "financial-grant",
        icon: "BriefcaseIcon",
        slug:'ngo_financial_grants'
      },
      {
        title: "التبرعات الخارجية",
        route: "international-Donations",
        icon: "BriefcaseIcon",
        slug:'ngo_international_donations'
      },
    ],
  },
];
